const PLATFORM_COMPANY_SLUG = 'vizionops';
const PLATFORM_WORKSPACE_ROLES = new Set(['super_admin', 'platform_admin']);

/**
 * Stable platform-admin identity check.
 *
 * Prefers the server-stamped `isPlatformAdmin` boolean (set by
 * sessionService.derivePlatformAdminIdentity), which survives the
 * client-context overlay. Falls back to the legacy
 * (role + platformCompanySlug || companySlug) derivation for sessions
 * that predate the server-side P1 change.
 *
 * IMPORTANT — this returns the *identity* answer, not the
 * *presentation* answer. Callers that want "should we render the
 * platform shell right now" must additionally check
 * !user.viewingClientPortal.
 */
export function isPlatformWorkspaceUser(user) {
  if (!user) return false;
  if (typeof user.isPlatformAdmin === 'boolean') return user.isPlatformAdmin;
  const role = String(user.role || '').trim().toLowerCase();
  const platformSlug = String(user.platformCompanySlug || user.companySlug || '').trim().toLowerCase();
  return PLATFORM_WORKSPACE_ROLES.has(role) && platformSlug === PLATFORM_COMPANY_SLUG;
}

export { PLATFORM_COMPANY_SLUG, PLATFORM_WORKSPACE_ROLES };
